import styled, { css } from 'styled-components'
import { useRef } from 'react'
import Background from '../layout/Background'
import Container from '../layout/Container'
import ArticleInfo from './ArticleInfo'
import ArticleContent from './ArticleContent'
import { PrintLinksProvider } from '../PrintLinks'

function Article( {
  articleInfo = null, 
  articleContent, 
  darkMode = false, 
  withBorder = false,
  gridType = 'story' as 'story' | 'normal',
  isArticle = false,
} ) {
  const printLinksRef = useRef<HTMLDivElement>( null )
  const articleInfoStartsWithImage = articleInfo[ 0 ]?.isImage
  const articleContentStartsWithImage = articleContent[ 0 ]?.typeHandle === 'image'

  return (
    <PrintLinksProvider>
      <Background 
        color={ darkMode ? 'black' : null }
        borderTop={ withBorder ? 'black' : null }
      >
        <Container>
          <StyledArticleGrid 
            $gridType={ gridType }
            $hasTwoCols={ articleInfo?.length > 0 }
            $collapseArticleInfoMargin={ articleInfoStartsWithImage }
            $collapseArticleContentMargin={ articleContentStartsWithImage }
            ref={ printLinksRef }
          >
            { articleInfo?.length > 0 && (
              <ArticleInfo 
                articleInfo={ articleInfo } 
                elementType={ isArticle ? 'footer' : 'div' }
              />
            ) }
            <ArticleContent 
              articleContent={ articleContent } 
              elementType={ isArticle ? 'main' : 'div' }
            />
          </StyledArticleGrid>
        </Container>
      </Background>
    </PrintLinksProvider>
  )
}

interface StyledArticle {
  $gridType: 'story' | 'normal',
  $hasTwoCols: boolean,
  $collapseArticleInfoMargin: boolean,
  $collapseArticleContentMargin: boolean,
}

export const StyledArticleGrid = styled.div<StyledArticle>`
  display: grid;
  grid-template-columns: 1fr;
  padding-bottom: 3rem;

  > *:first-child {
    margin-top: ${ p => p.$collapseArticleInfoMargin ? '0' : '3rem' };
    margin-bottom: 3rem;
  }

  ${ p => p.$hasTwoCols && css`
    @media ( min-width: 930px ) {
      grid-template-columns: 33.333% 1fr;
      margin: 0 -1rem;
      padding-bottom: 4rem;
      
      > * {
        margin: 0 1rem;
        
        &:nth-child( 2 ) {
          margin-top: ${ p.$collapseArticleContentMargin ? '0' : '3rem' };
        }
      }
    }
    
    ${ p.$gridType === 'story' && css`
      @media ( min-width: 1150px ) {
        grid-template-columns: ${ 33.333 - ( 100 / 23 ) }% 1fr;
        margin: 0 -2rem;
        
        > * {
          margin: 0 2rem;

          &:first-child {
            margin-top: ${ p.$collapseArticleInfoMargin ? '0' : '4rem' };
          }
          
          &:last-child {
            margin-top: ${ p.$collapseArticleContentMargin ? '0' : '4rem' };
          }
        }
      }
    ` }
  ` }
`

export default Article
